// Utility functions for tile group operations

// Global constant for darkening background tiles (CSS filter brightness)
export const BACKGROUND_DARKENING = 0.4; // 60% brightness for darkening effect

export const calculateGroupOutline = (groupCoordinates: [number, number][]): string => {
    if (groupCoordinates.length === 0) return '';

    // Create a set for quick lookup of occupied coordinates
    const coordSet = new Set(groupCoordinates.map(([x, y]) => `${x},${y}`));
    
    // Find all edge segments
    const edges: string[] = [];
    
    groupCoordinates.forEach(([x, y]) => {
        // Check each side of the 32x32 tile
        const sides = [
            { start: [x, y], end: [x + 32, y], dir: 'top' },           // Top edge
            { start: [x + 32, y], end: [x + 32, y + 32], dir: 'right' }, // Right edge
            { start: [x + 32, y + 32], end: [x, y + 32], dir: 'bottom' }, // Bottom edge
            { start: [x, y + 32], end: [x, y], dir: 'left' }           // Left edge
        ];

        sides.forEach(({ start, end, dir }) => {
            // Determine if this edge is on the perimeter
            let isPerimeter = false;
            
            if (dir === 'top' && !coordSet.has(`${x},${y - 32}`)) isPerimeter = true;
            if (dir === 'right' && !coordSet.has(`${x + 32},${y}`)) isPerimeter = true;
            if (dir === 'bottom' && !coordSet.has(`${x},${y + 32}`)) isPerimeter = true;
            if (dir === 'left' && !coordSet.has(`${x - 32},${y}`)) isPerimeter = true;
            
            if (isPerimeter) {
                edges.push(`M ${start[0]} ${start[1]} L ${end[0]} ${end[1]}`);
            }
        });
    });

    return edges.join(' ');
};

export const calculateBoundingBox = (groupCoordinates: [number, number][]) => {
    if (groupCoordinates.length === 0) return null;
    
    const xs = groupCoordinates.map(([x]) => x);
    const ys = groupCoordinates.map(([, y]) => y);
    
    return {
        x: Math.min(...xs) - 5,
        y: Math.min(...ys) - 5,
        width: Math.max(...xs) - Math.min(...xs) + 32 + 10,
        height: Math.max(...ys) - Math.min(...ys) + 32 + 10
    };
};